import React, {  createContext, useState } from 'react';
import { toast } from 'react-toastify';
import { apiLucree } from '~/services/api';




export const TokenContext = createContext([]);

export function TokenProvider(props) {
	const { children } = props;

	const [loadingToken, setLoadingToken] = useState(true);

	async function authToken() {
		try {
			const credentials = {
				username: 'daniel.nascimento',
				password: 'acessoLucree#2018',
			};
			const response = await apiLucree.post(
				'autenticacao/v1/',
				credentials
			);

			return response;
		} catch (error) {
			toast.error(
				'Os dados de autenticação de token não foram carregados. Por favor atualize a página'
			);
		}
		return null;
	}

	async function callVerifyDoc(doc) {
		try {
			return await apiLucree.post(`authentication/api/verifica-documento/`, {
				documento: doc,
				headers: {
					'Content-Type': 'application/json',
				},
			}).then((res) => {
				setLoadingToken(false);
				return res;
			});
		} catch (error) {
			setLoadingToken(false);
			return error.response;
		}
	}

	async function getCodeByType(doc, type) {
		try {
			return await apiLucree.post(`authentication/api/solicita-envio-codigo-totp/`, {
				documento: doc,
				metodo_envio_totp_code: type,
				headers: {
					'Content-Type': 'application/json',
				},
			}).then((res) => {
				setLoadingToken(false);
				return res;
			});
		} catch (error) {
			toast.error('Ocorreu um erro. Tente novamente.')
			setLoadingToken(false);
			return error.response;
		}
	}

	async function callVerifyCode(doc, code) {
		try {
			return await apiLucree.post(`authentication/api/verifica-codigo-totp/`, {
				documento: doc,
				codigo_totp: code,
				headers: {
					'Content-Type': 'application/json',
				},
			}).then((res) => {
				setLoadingToken(false);
				return res;
			});
		} catch (error) {
			toast.error('Ocorreu um erro. Tente novamente.')
			setLoadingToken(false);
			return error.response;
		}
	}



	return (
		<TokenContext.Provider
			value={{
				authToken,
				loadingToken,
				setLoadingToken,
				callVerifyDoc,
				getCodeByType,
				callVerifyCode,
			}}>
			{children}
		</TokenContext.Provider>
	);
}
